import { Keyword } from "@ndn/naming-convention2";
import { Name, TT } from "@ndn/packet";
import { EvDecoder, Extensible } from "@ndn/tlv";
/** `32=metadata` component. */
export const MetadataKeyword = Keyword.create("metadata");
function makeEvd(title) {
    return new EvDecoder(title)
        .add(TT.Name, (t, { value }) => t.name = new Name(value), { required: true })
        .setIsCritical(EvDecoder.neverCritical);
}
const EVD = makeEvd("Metadata");
/** Metadata packet content. */
export class Metadata {
    name;
    /**
     * Constructor.
     * @param name - Versioned name.
     */
    constructor(name = new Name()) {
        this.name = name;
    }
    static decodeFrom(decoder) {
        return EVD.decodeValue(new Metadata(), decoder);
    }
    encodeTo(encoder) {
        encoder.prependValue(this.name);
    }
}
(function (Metadata) {
    /** Class decorator on an extensible {@link Metadata} subclass. */
    function extend(ctor, ctx) {
        void ctx; // cannot use due to https://github.com/vitest-dev/vitest/issues/3140
        const registry = new ctor()[Extensible.TAG];
        const evd = makeEvd(ctor.name).setUnknown(registry.decodeUnknown);
        Object.defineProperty(ctor, "decodeFrom", {
            value(decoder) {
                return evd.decodeValue(new ctor(), decoder);
            },
        });
        Object.defineProperty(ctor.prototype, "encodeTo", {
            value(encoder) {
                encoder.prependValue(this.name, ...registry.encode(this));
            },
        });
    }
    Metadata.extend = extend;
})(Metadata || (Metadata = {}));
